import { Pipe, PipeTransform } from '@angular/core';
import { SortInterface } from '../components/sort-control/sort.interface';
import { sortByProperty } from '../../core/utils/collection.utils';

@Pipe({
  name: 'sort'
})
export class SortPipe implements PipeTransform {
  transform(value: any[], sort: SortInterface): any[] {
    return (sort) ? sortByProperty(sort.attribute, sort.type, sort.reverse, value) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/shared/pipes/sort.pipe.ts